<div class="ResetAccountPasswordDialog" [formGroup]="inputForm">
  <div class="ResetAccountPasswordDialog-row">
    <p>New Password</p>
    <app-text-field
      placeholder="New password"
      formControlName="password"
      type="password"></app-text-field>
  </div>
  <div class="ResetAccountPasswordDialog-row">
    <p>Re-enter password</p>
    <app-text-field
      placeholder="Re-etner password"
      type="password"
      formControlName="password_repeat"></app-text-field>
    <mat-error
      *ngIf="
        (passwordRepeat?.touched || passwordRepeat?.dirty) &&
        passwordRepeat?.errors?.passwordNotPatch
      "
      >Passwords did not match</mat-error
    >
  </div>
</div>
